import useUrlParams from "../../../../../customHooks/useUrlParams";
import useAssetTableJson from "../../../../../json/useAssetTableJson";
import { TableHeaderProps } from "../../../../../utils/types";
import {
  GridColDef,
  GridColumnVisibilityModel,
  GridValidRowModel,
  GridAlignment
} from "@mui/x-data-grid-pro";
import EyeWhite from "../../../../../images/EyeWhite.svg";
import { useContext, useEffect, useState } from "react";
import { ColumnVisibilityFor } from "../../../../../utils/Enum.Datagrid";
import { StyledDatagrid } from "../../../../../styles/DatagridStyles";
import { TABLE_ROW_HEIGHT } from "../../../../../styles/Variables";
import { Button } from "../../../../../stories/Button/Button";
import { useNavigate } from "react-router-dom";
import { GetJunctionCounters } from "../../masters/subsidary/junctions/queries/queries";
import {
  GetJunctionCountersData,
  GetJunctionCountersVars
} from "../../masters/subsidary/junctions/queries/types";
import { useLazyQuery } from "@apollo/client";
import useToken from "../../../../../customHooks/useToken";
import { MapsContext } from "../../maps/context/context";
import { mapsPayloadType } from "../../maps/context/reducer";
import { EMPTY_STRING } from "../../../../../utils/constants";
import JunctionDetails from "../modal/JunctionDetails";
const SignalTypes = () => {
  const { customer_id, company_id } = useUrlParams();
  const { handleToken } = useToken();
  const { state, dispatch } = useContext(MapsContext);

  const [junctionList, setJunctionList] = useState(false);
  const navigate = useNavigate();
  const { Reports } = useAssetTableJson();
  const dynamicHeaders: TableHeaderProps[] = Reports.JunctionType.map(
    (header) => ({
      headerName: header.headerName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      hideable: header.hideable,
      cellClassName: header.cellClassName,
      renderCell: (params) => {
        if (header.field === "actions") {
          return (
            <>
              <button
                className="maps-comp-details__view"
                onClick={() => {
                  dispatch({
                    type: mapsPayloadType.JUNCTION_TYPE,
                    payload: {
                      junctionType: params.row.type_of_signal
                        ? params.row.type_of_signal
                        : EMPTY_STRING
                    }
                  });
                  setJunctionList(!junctionList);
                }}
              >
                View Details
                <img src={EyeWhite} alt="" />
              </button>
            </>
          );
        }

        return params.value;
      }
    })
  );

  const columns: GridColDef[] = [...dynamicHeaders];

  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({});

  useEffect(() => {
    const savedModel = localStorage.getItem(ColumnVisibilityFor.JUNCTION_TYPE);
    if (savedModel) {
      setColumnVisibilityModel(JSON.parse(savedModel));
    }
  }, []);

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem(
      ColumnVisibilityFor.JUNCTION_TYPE,
      JSON.stringify(newModel)
    );
  };
  const [getJunctions, { data, loading, fetchMore }] = useLazyQuery<
    GetJunctionCountersData,
    GetJunctionCountersVars
  >(GetJunctionCounters);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = await handleToken();
        if (token && customer_id) {
          getJunctions({
            variables: {
              token,
              customerID: customer_id,
              empID: 0,

              byJType: true
            }
          });
        }
      } catch (err) {
        console.error((err as Error).message);
      }
    };
    fetchData();
  }, [customer_id, getJunctions]);
  const rows: GridValidRowModel[] = (data?.GetJunctionCounters ?? []).map(
    (res, index) => ({
      id: index + 1,
      total_no_of_asset: res.totalJunctions,
      working: res.working,
      not_working: res.notWorking,
      planned: res.planned,
      in_progress: res.inProgress,
      installed: res.installed,
      shifting: res.shifting,
      commissioned: res.commissioned,
      decommissioned: res.deCommissioned,
      type_of_signal: res.jType
    })
  );
  return (
    <>
      {junctionList ? (
        <>
          <JunctionDetails />
        </>
      ) : (
        <>
          <div className="signal-wise-report__types">
            <div className="signal-wise-report__types--table">
              <StyledDatagrid
                columns={columns}
                rows={rows}
                rowHeight={TABLE_ROW_HEIGHT}
                columnVisibilityModel={columnVisibilityModel}
                onColumnVisibilityModelChange={handleColumnVisibilityChange}
                initialState={{
                  columns: {
                    columnVisibilityModel: columnVisibilityModel
                  }
                }}
                disableRowSelectionOnClick
                hideFooter
              />
            </div>
            <div className="row g-0">
              <div className="col">
                <Button mode="back" onClick={() => navigate(-1)} />
              </div>
              <div className="col-4 flex-end">
                <div className="overall-total-count">
                  Total <b>{rows.length}</b>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default SignalTypes;
